import request from '@/utils/request';
import { department } from './department';
const API_URL: string = '/Project'

export function project(uesMethod: string, params: ParamsInfo | null, data: number[] | ProjectInfo | null, funName: string = '') {
  return request({
    url: API_URL + funName,
    method: uesMethod,
    params,
    data
  });
}

export interface ProjectInfo {
  organizationId?: number
  id?: number
  name?: string
  address?: string
  departmentId?: any
  propertyId?: any
  startTime?: any,
  stopTime?: any,
  intervalDay?: number
  paymentType?: number
  receivableAmount: number
}

export interface ParamsInfo {
  organizationId?: any
  projectName?: string
  pageNum?: number
  pageSize?: number
  projectId?: number
}
